import React from 'react'
import PropTypes from 'prop-types'
import P from '../../Typography/P'
import dictionary from '../../../../dictionary'
import LegendsRadioGroup from '../LegendsRadioGroup'
import LegendsTooltip from '../LegendsTooltip'
import styles from '../radio-group.module.scss'

function Icon(props) {
  const { onChange, name, current, content } = props
  return (
    <div className={styles.root}>
      <P size="small" className={styles.legend}>
        Доступные материалы
      </P>
      <LegendsRadioGroup
        defaultValue={current}
        value={current}
        ariaLabel={name}
        className={styles.group}
        onChange={(value) => onChange(name, value)} 
      >
        {content.map(({ value, label, disabled }) => (
          <LegendsTooltip
            key={`${name}-${value}`}
            title={dictionary.item[value]}
            disabled={disabled}
          >
            <span
              className={styles.labelImage}
              style={{ backgroundImage: `url(${label})` }}
            />
          </LegendsTooltip>
        ))}
      </LegendsRadioGroup>
    </div>
  )
}

Icon.propTypes = {
  productName: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func,
}

export default Icon
